import Route from 'cio/routes/base';
import window from 'ember-window-mock';

export default class AccountReceiptsShowRedirectRoute extends Route {
  redirect(params) {
    window.location = `/settings/receipts/${params.id}`;
  }
}
